<template>
  <el-container class="dashboard-container">
    <el-aside width="200px">
      <div class="menu-logo">FOS 控制台</div>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <el-menu-item index="dashboard" @click="handleMenuClick('dashboard')">
          <el-icon><Monitor /></el-icon>
          <span>控制台</span>
        </el-menu-item>
        <el-menu-item index="temporary-keys" @click="handleMenuClick('temporary-keys')">
          <el-icon><Timer /></el-icon>
          <span>临时密钥</span>
        </el-menu-item>
        <!-- 修改“接入说明”为 el-sub-menu -->
        <el-sub-menu index="access-instructions">
          <template #title>
            <el-icon><Compass /></el-icon>
            <span>接入说明</span>
          </template>
          <el-menu-item class="sub-menu-item" index="access-instructions/overview" @click="handleSubMenuClick('access-instructions/overview')">
            <span>概述概要</span>
          </el-menu-item>
          <el-menu-item class="sub-menu-item" index="access-instructions/config-generation" @click="handleSubMenuClick('access-instructions/config-generation')">
            <span>配置生成</span>
          </el-menu-item>
          <el-menu-item class="sub-menu-item" index="access-instructions/get-access-key" @click="handleSubMenuClick('access-instructions/get-access-key')">
            <span>获取通行密钥</span>
          </el-menu-item>
          <el-menu-item class="sub-menu-item" index="access-instructions/file-upload" @click="handleSubMenuClick('access-instructions/file-upload')">
            <span>文件上传</span>
          </el-menu-item>
          <el-menu-item class="sub-menu-item" index="access-instructions/file-download" @click="handleSubMenuClick('access-instructions/file-download')">
            <span>文件下载</span>
          </el-menu-item>
          <el-menu-item class="sub-menu-item" index="access-instructions/file-path-query" @click="handleSubMenuClick('access-instructions/file-path-query')">
            <span>文件路径查询</span>
          </el-menu-item>
          <el-menu-item class="sub-menu-item" index="access-instructions/file-delete" @click="handleSubMenuClick('access-instructions/file-delete')">
            <span>文件删除</span>
          </el-menu-item>
          <!-- 新增“附录”节点 -->
          <el-menu-item class="sub-menu-item" index="access-instructions/appendix" @click="handleSubMenuClick('access-instructions/appendix')">
            <span>附录</span>
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item index="call-tool" @click="handleMenuClick('call-tool')">
          <el-icon><Tools /></el-icon>
          <span>调试工具</span>
        </el-menu-item>
        <!-- 新增“操作数据”菜单项 -->
        <el-menu-item index="operation-data" @click="handleMenuClick('operation-data')">
          <el-icon><Document /></el-icon>
          <span>操作数据</span>
        </el-menu-item>
        <!-- 根据 roleId 判断是否显示“余量充值”菜单 -->
        <template v-if="roleId === 1">
          <el-menu-item index="recharge" @click="handleMenuClick('recharge')">
            <el-icon><Wallet /></el-icon>
            <span>余量充值</span>
          </el-menu-item>
        </template>
      </el-menu>
      <!-- 修改部分：使用绝对定位 -->
      <div class="menu-footer">
        Power by <a href="https://woqu.linyaoyan.top" style="color: inherit;" target="_blank">©蜗趣记账</a>
      </div>
    </el-aside>
    <el-container>
      <el-header>
        <div class="header-content">
          <div class="left-nav">
            <div class="breadcrumb">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ currentPage }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="right-nav">
            <router-link to="/" class="home-button">首页</router-link>
            <div class="user-info">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ nickName }}
                  <el-icon class="el-icon--right"><ArrowDown /></el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="profile">个人信息</el-dropdown-item>
                    <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-header>
      <el-main ref="mainContainer">
        <slot></slot>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Monitor, Timer, Compass, ArrowDown, Tools, Document, Wallet } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import service from '@/utils/http'
import { generateTimestamp, generateToken } from '@/utils/crypto'
import { API_PATHS } from '@/config/api'

const route = useRoute()
const router = useRouter()
const activeMenu = ref('')
const nickName = ref('')
const roleId = ref(null) 
const mainContainer = ref(null) // 新增 ref

const pathMap = {
  '/dashboard': 'dashboard',
  '/temporary-keys': 'temporary-keys',
  '/access-instructions/overview': 'access-instructions/overview',
  '/access-instructions/config-generation': 'access-instructions/config-generation',
  '/access-instructions/get-access-key': 'access-instructions/get-access-key',
  '/access-instructions/file-upload': 'access-instructions/file-upload',
  '/access-instructions/file-download': 'access-instructions/file-download',
  '/access-instructions/file-path-query': 'access-instructions/file-path-query',
  '/access-instructions/file-delete': 'access-instructions/file-delete',
  '/access-instructions/appendix': 'access-instructions/appendix',
  '/call-tool': 'call-tool',
  '/operation-data': 'operation-data',
  '/recharge': 'recharge'
}

onMounted(() => {
  const userInfo = localStorage.getItem('userInfo')
  if (userInfo) {
    const parsedUserInfo = JSON.parse(userInfo)
    nickName.value = parsedUserInfo.nickName || ''
    roleId.value = parsedUserInfo.roleId 
  } else {
    router.push('/auth')
  }
  
  if (route.path!== '/profile') {
    activeMenu.value = pathMap[route.path] || 'dashboard'
  } else {
    activeMenu.value = ''
  }
})

// 监听路由变化，更新 activeMenu 并滚动到顶部
watch(() => route.path, async (newPath) => {
  if (newPath!== '/profile') {
    activeMenu.value = pathMap[newPath] || 'dashboard'
  } else {
    activeMenu.value = ''
  }
  await nextTick(() => {
    // 直接操作 el-main 的DOM元素
    const elMain = mainContainer.value?.$el
    if (elMain) {
      console.log('重置滚动条', elMain)
      elMain.scrollTop = 0 // 直接操作DOM
    }
  });
})

const handleMenuClick = (index) => {
  activeMenu.value = index;
  router.push(`/${index}`);
}

const handleSubMenuClick = (index) => {
  // 避免重复跳转
  if (index === 'access-instructions') {
    return;
  }
  activeMenu.value = index;
  router.push(`/${index}`);
}

const currentPage = computed(() => {
  const pathMap = {
    '/dashboard': '控制台',
    '/temporary-keys': '临时密钥',
    '/access-instructions/overview': '概述概要',
    '/access-instructions/config-generation': '配置生成',
    '/access-instructions/get-access-key': '获取通行密钥',
    '/access-instructions/file-upload': '文件上传',
    '/access-instructions/file-download': '文件下载',
    '/access-instructions/file-path-query': '文件路径查询',
    '/access-instructions/file-delete': '文件删除',
    '/call-tool': '调试工具',
    '/profile': '个人信息',
    '/operation-data': '操作数据',
    '/recharge': '余量充值'
  }
  return pathMap[route.path] || '控制台'
})

const handleCommand = (command) => {
  if (command === 'logout') {
    ElMessageBox.confirm('确定要退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      try {
        const userInfo = localStorage.getItem('userInfo');
        const parsedUserInfo = userInfo ? JSON.parse(userInfo) : {};
        const userId = parsedUserInfo.userId;
        const timestamp = generateTimestamp();
        const token = generateToken({ userId, timestamp });

        // 准备请求参数
        const params = {
          userId,
          timestamp,
          token
        }

        // 将参数转换为 URL 查询字符串
        const formData = new URLSearchParams()
        Object.keys(params).forEach(key => {
          formData.append(key, params[key])
        })

        // 使用 service.post 发送请求
        await service.post(
          `${API_PATHS.logout}`,
          formData
        )
        localStorage.removeItem('userInfo');
        router.push('/auth');
      } catch (error) {
        ElMessage.error(error.message || '退出登录失败');
      }
    }).catch(() => {
      // 用户取消了退出操作
    });
  } else if (command === 'profile') {
    activeMenu.value = '';
    router.push('/profile');
  }
}
</script>

<style scoped>
.dashboard-container {
  height: 100vh;
  display: flex;
  width: 100%;
}

.el-aside {
  background-color: #304156;
  width: 200px !important;
  transition: width 0.3s;
  flex-shrink: 0;
  /* 修改部分：禁止滚动 */
  overflow-y: visible;
}

/* 移除滚动条相关样式 */
.el-aside::-webkit-scrollbar {
  display: none;
}

.menu-logo {
  color: white;
  font-size: 20px;
  text-align: left;
  padding: 20px;
}

.el-menu {
  border-right: none;
  background-color: #304156;
  margin-top: 10px;
}

.el-menu-vertical {
  height: 100%;
}

.sub-menu-item {
  background-color: #263445; /* 不同底色 */
  padding-left: 50px !important; /* 向右缩进 */
}

:deep(.el-menu-item) {
  color: #bfcbd9;
}

:deep(.el-menu-item.is-active) {
  color: #409EFF;
  background-color: #263445;
}

:deep(.el-menu-item:hover) {
  background-color: #263445;
}

.el-header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 0;
  height: 60px;
  flex-shrink: 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding-left: 20px;
  /* 新增样式，增加右侧内边距 */
  padding-right: 20px;
}

.right-nav {
  display: flex;
  align-items: center;
  gap: 20px;
}

.home-button {
  background-color: #409EFF;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  text-decoration: none;
}

.user-info {
  cursor: pointer;
  display: flex;
  align-items: center;
}

/* 设置二级子菜单区域的底色和缩进 */
:deep(.el-sub-menu__children) {
  background-color: #263445; /* 不同底色 */
  padding-left: 20px; /* 向右缩进 */
}

/* 新增底部文案样式 */
.menu-footer {
  position: absolute;
  bottom: 0px;
  /* left: 0px; */
  padding: 10px 20px;
  width: 200px;
  background-color: #344555;

  color: #bfcbd9;
  font-size: 12px;
  /* 修改部分：底部文案居左显示 */
  text-align: left;
}
</style>